export const REIMBURSEMENT_TYPE = [
  {value: 0, title: 'Regular'},
  {value: 1, title: 'MICGP CKT EXAM PREP'},
  {value: 2, title: 'MICGP CCT EXAM PREP'},
];

export const REIMBURSEMENT_TYPE_NAME = {
  regular: 'Regular',
  ckt: 'CKT',
  cct: 'CCT',
};

export const REIMBURSEMENT_TYPE_FOR_SHOW = {
  0: 'Regular',
  1: 'CKT',
  2: 'CCT',
};

export const REIMBURSEMENT_TYPES = {
  regular: 0,
  ckt: 1,
  cct: 2,
};



// WEBPACK FOOTER //
// ./src/constants/reimbursementTypes.js